module.exports = "<div>\r\n      <span class=\"renderer-default\">\r\n            <a class=\"hyperlink-content\" (click)=\"downloadFile(params.node.data['fileName'].cVal);\"> {{ params.node.data['fileName'].cVal }} </a>\r\n      </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/work-order-management/configuration/work-order-routing/aggrid-custom-cell/filename-cell-renderer.component.html
// module id = ../../../../../src/app/features/inventory/work-order-management/configuration/work-order-routing/aggrid-custom-cell/filename-cell-renderer.component.html
// module chunks = main